import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  type?: 'info' | 'warning';
  children: React.ReactNode;
};

/**
 * ガイド画面で補足情報を表示するボックス
 */
const GuideInfoBox: React.FC<Props> = ({ type = 'info', children }) => {
  const isWarning = type === 'warning';
  return (
    <Box
      sx={{
        borderLeft: 3,
        borderColor: isWarning ? 'warning.main' : 'info.main',
        borderRadius: 1,
        bgcolor: 'action.hover',
        p: 1.5,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="flex-start">
        {isWarning ? (
          <WarningAmberIcon sx={{ fontSize: 20, color: 'warning.main', mt: 0.2 }} />
        ) : (
          <InfoOutlinedIcon sx={{ fontSize: 20, color: 'info.main', mt: 0.2 }} />
        )}
        <Typography variant="body2" color="text.secondary">
          {children}
        </Typography>
      </Stack>
    </Box>
  );
};

export default GuideInfoBox;
